import React, { useEffect, useState, useRef } from 'react'
import '../../assets/css/App.css'
// import '../../assets/css/CDPRequestConfirmPage.css'
// import SecurityBanner from '../layout/SecurityBanner'
import { useLocation, useNavigate } from 'react-router-dom'
// import { CDP_PUBLIC_URL, GOOGLE_RECAPTCHA_JS_URL, REACT_APP_SITE_KEY, RECAPTCHA_ENABLED } from '../../utils/Constants'
import { CDP_PUBLIC_URL, REACT_APP_SITE_KEY } from '../../utils/Constants'
import { useIntl } from 'react-intl'
import ReCAPTCHA from 'react-google-recaptcha'
import { callSaveAPI } from '../../api/CDPAPI'

const CDPRequestConfirmPage = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const values = location.state
     const [loading, setLoading] = useState(false)
    const captchaRef = useRef(null)
    const [finishStatus, setFinishStatus] = useState(false)
    const intl = useIntl()
    const checkboxestring = [values.whereFrom01, values.whereFrom02,
    values.whereFrom03, values.whereFrom04,
    values.whereFrom05, values.whereFrom06,
    values.whereFrom07, values.whereFrom08,
    values.whereFrom09, values.whereFrom10].filter(Boolean)

    const onBackButtonEvent = (e) => {
        e.preventDefault()
        if (!finishStatus) {
            if (window.confirm(intl.formatMessage({ id: 'browserBackButtonMsg' }))) {
                setFinishStatus(true)
                navigate(`${CDP_PUBLIC_URL}/recruit`, { state: {} })
            } else {
                window.history.pushState(null, null, window.location.pathname)
                setFinishStatus(false)
            }
        }
    }

    useEffect(() => {
        document.title = 'CDPエントリー｜コンサルタント社員採用｜メットライフ生命'
        window.scrollTo(0, 0)
        window.history.pushState(null, null, window.location.pathname)
        window.addEventListener('popstate', onBackButtonEvent)
        return () => {
            window.removeEventListener('popstate', onBackButtonEvent)
        }
    }, [])

    const handleBack = () => {
        navigate(`${CDP_PUBLIC_URL}/recruit`, { state: { formData: values, isBack: true } })
    }

    const handleSubmit = async (e) => {
       // document.getElementById('entryCDP').scrollIntoView()
         window.scrollTo(0, document.body.scrollHeight)
         setLoading(true)
        e.preventDefault()
    const token = await captchaRef.current.executeAsync()
                    await callSaveAPI('confirm', { ...values, captchaToken: token })
                    .then(res => {
                            if (res.status === 200) {
                                setLoading(false)
                                // values.createdDate = response.createdDate
                                 captchaRef.current.reset()
                                // responseData = response
                                navigate(`${CDP_PUBLIC_URL}/recruit/complete`, { state: values })
                            } else {
                                if (window.confirm(intl.formatMessage({ id: 'submissionError' }))) {
                                    navigate(`${CDP_PUBLIC_URL}/recruit`, { state: values })
                                } else {
                                    setLoading(false)
                                }
                            }
                        }
                    ).catch(() => {
                        if (window.confirm(intl.formatMessage({ id: 'submissionError' }))) {
                            navigate(`${CDP_PUBLIC_URL}/recruit`, { state: values })
                        } else {
                            setLoading(false)
                        }
                    })
    }
    return (
        <div id="contents">
            <div className="entrySection cdpConfirm">
                <div className="sectionFrame">
                    <div className="sectionLeadTxt">入力いただいた内容を確認の上、送信ボタンを押してください。<br />入力内容を変更する場合は、下部の戻るボタンを押して入力画面に戻り、編集を行ってください。</div>

                    <div className="formSheet">

                        <dl className="formName">
                            <dt><div className="dtWrap"><div className="formIcon"></div>{intl.formatMessage({ id: 'nameTitle' })}</div></dt>
                            <dd><p className="confirmTxt">{values.nameKanji}</p></dd>
                        </dl>

                        <dl className="formSpelling">
                            <dt><div className="dtWrap"><div className="formIcon"></div>フリガナ</div></dt>
                            <dd><p className="confirmTxt">{values.nameKana}</p></dd>
                        </dl>

                        <dl className="formAge">
                            <dt><div className="dtWrap"><div className="formIcon"></div>{intl.formatMessage({ id: 'age' })}</div></dt>
                            <dd><p className="confirmTxt">{values.age}</p></dd>
                        </dl>

                        <dl className="formTelephone">
                            <dt><div className="dtWrap"><div className="formIcon"></div>{intl.formatMessage({ id: 'phoneTile' })}</div></dt>
                            <dd><p className="confirmTxt">{values.phoneNumber}</p></dd>
                        </dl>

                        <dl className="formMail">
                            <dt><div className="dtWrap"><div className="formIcon"></div>{intl.formatMessage({ id: 'mailId' })}</div></dt>
                            <dd><p className="confirmTxt">{values.mailId}</p><p className="formMsg02">＊未登録のメールアドレスの拒否設定、ドメイン受信拒否設定等されている方は、解除をお願いします。</p></dd>
                        </dl>

                        <dl className="formAcademicBg">
                            <dt><div className="dtWrap"><div className="formIcon"></div>{intl.formatMessage({ id: 'finalEduBkgTitle' })}</div></dt>
                            <dd><p className="confirmTxt">{values.finalEduBgTypes}</p></dd>
                        </dl>

                        <dl className="formWorkExperience">
                            <dt><div className="dtWrap"><div className="formIcon"></div>{intl.formatMessage({ id: 'workExperienceTitle' })}</div></dt>
                            <dd><p className="confirmTxt">{values.workExperienceTypes}</p></dd>
                        </dl>

                        <dl className="formChangeOccupation">
                            <dt><div className="dtWrap"><div className="formIcon"></div>{intl.formatMessage({ id: 'changeOccupationTitle' })}</div></dt>
                            <dd><p className="confirmTxt">{values.changeOccupationTypes}</p></dd>
                        </dl>

                        <dl className="formNowOccupation">
                            <dt><div className="dtWrap"><div className="formIcon"></div>{intl.formatMessage({ id: 'nowOccupationTitle' })}</div></dt>
                            <dd><p className="confirmTxt">{values.nowOccupationTypes}</p></dd>
                        </dl>

                        <dl className="formWhereComeFrom">
                            <dt><div className="dtWrap"><div className="formIcon"></div>{intl.formatMessage({ id: 'whereComeFromTitle' })}</div></dt>
                            <dd>
                                <p className="confirmTxt">{checkboxestring.join(', ')}</p>
                            </dd>
                        </dl>

                        <dl className="formWhereCDP">
                            <dt><div className="dtWrap"><div className="formIcon"></div>{intl.formatMessage({ id: 'whereCDPTitle' })}</div></dt>
                            <dd><p className="confirmTxt">第1希望：{values.whereCDPMemoTypes1}<br />第2希望：{values.whereCDPMemoTypes2}</p></dd>
                        </dl>
                        <ReCAPTCHA sitekey={ REACT_APP_SITE_KEY } size='invisible' ref={captchaRef} />
                        {
                            loading
                                ? (<div className='spinContainer'>
                                    <div className='spin'></div>
                                    <span><h2>{intl.formatMessage({ id: 'LoadingMsg' })}</h2></span>
                                </div>
                                )
                                : <div className="formBtnSet clearfix">
                                    <br/>
                                <br/>
                                <br/>
                                    <input type="submit" onClick={handleSubmit} className='btnStyle registerBtn' value={intl.formatMessage({ id: 'saveButton' })} />
                                    <button onClick={handleBack} className='btnStyle editBtn'>{intl.formatMessage({ id: 'backButton' })}</button>
                                </div>
                        }
                    </div>
                </div>
            </div>
            <div className="pageup">
                <p><a href=""></a></p>
            </div>
        </div>
    )
}

export default CDPRequestConfirmPage
